<template>
    <div class="">
        <Header v-on:headerToChild="onSearchSubmit"></Header>

        <main class="u-main">
            <Navigation :tenant="tenant_id"></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">Bookings

                        <!-- Tenant Switcher -->
                        <div class="pull-rights ui-mt-15 pull-right">
                            <div class="dropdown">
                                <button type="button"
                                    class="btn btn-dark btn-sm dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    :disabled="tenantLoading">
                                    <span class="btn-icon ti-home mr-2"></span>
                                    <span v-if="!tenantLoading"> {{ tenant_name }}</span>
                                    <span v-if="tenantLoading">
                                        <span class="spinner-grow spinner-grow-sm mr-1" role="status" aria-hidden="true"></span>Loading...
                                    </span>
                                </button>
                                <div class="dropdown-menu">
                                    <a v-if="auth.role == 'root'"
                                        class="dropdown-item dropdown-pad"
                                        href="javascript:;"
                                        @click="changeTenant(0, 'All Tenants')">All Tenants
                                    </a>
                                    <a v-for="(tenant, index) in tenants"
                                        :key="index"
                                        class="dropdown-item dropdown-pad"
                                        href="javascript:;"
                                        :class="(tenant.authority) ? '' : 'hidden'"
                                        @click="changeTenant(tenant.id, tenant.name)">
                                        &nbsp; {{ tenant.name }} &nbsp;
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- End Tenant Switcher -->
                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Bookings</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

                    <!-- Card -->
                    <div class="row">
                        <div class="col-md-12 mb-5">
                            <div class="card">
                                <header class="card-header">
                                    <h2 class="h4 card-header-title">

                                        <!-- Status Filters -->
                                        <a href="javascript:;" class="pg-hd"
                                            :class="(filterStatus == '') ? 'active' : ''"
                                            @click="changeStatus('')">All</a>
                                        &nbsp;|&nbsp;
                                        <a href="javascript:;" class="pg-hd"
                                            :class="(filterStatus == 'pending') ? 'active' : ''"
                                            @click="changeStatus('pending')">Pending</a>
                                        &nbsp;|&nbsp;
                                        <a href="javascript:;" class="pg-hd"
                                            :class="(filterStatus == 'paid') ? 'active' : ''"
                                            @click="changeStatus('paid')">Paid</a>
                                        &nbsp;|&nbsp;
                                        <a href="javascript:;" class="pg-hd"
                                            :class="(filterStatus == 'cancelled') ? 'active' : ''"
                                            @click="changeStatus('cancelled')">Cancelled</a>
                                        &nbsp;|&nbsp;
                                        <a href="javascript:;" class="pg-hd"
                                            :class="(filterStatus == 'refunded') ? 'active' : ''"
                                            @click="changeStatus('refunded')">Refunded</a>

                                        <!-- Show Entries -->
                                        <div class="dropdown pull-right ui-mt-10">
                                            <button type="button" class="btn btn-light btn-sm dropdown-toggle"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Show {{ show }}
                                            </button>
                                            <div class="dropdown-menu ui-min-w100">
                                                <a class="dropdown-item cursor-pointer" @click="onShow(10)">10</a>
                                                <a class="dropdown-item cursor-pointer" @click="onShow(25)">25</a>
                                                <a class="dropdown-item cursor-pointer" @click="onShow(50)">50</a>
                                                <a class="dropdown-item cursor-pointer" @click="onShow(100)">100</a>
                                            </div>
                                        </div>
                                        <!-- End Show Entries -->

                                    </h2>
                                </header>

                                <div class="card-body pt-0">
                                    <div class="table-responsive">
                                        <table class="table table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th style="width:13%">Confirmation #</th>
                                                    <th style="width:10%">Tenant</th>
                                                    <th style="width:16%">Package</th>
                                                    <th style="width:11%">Travel Date</th>
                                                    <th style="width:15%">Traveler</th>
                                                    <th style="width:10%">IP</th>
                                                    <th style="width:9%" class="text-center">Total</th>
                                                    <th style="width:5%" class="text-center">Adults</th>
                                                    <th style="width:6%" class="text-center">Status</th>
                                                    <th style="width:5%" class="text-center">Actions</th>
                                                </tr>
                                            </thead>

                                            <tbody v-if="dataLoading">
                                                <tr>
                                                    <td colspan="10" class="text-center">
                                                        <div class="spinner-grow" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tbody v-if="!dataLoading && !rows.length">
                                                <tr>
                                                    <td colspan="10" class="text-center">No results found.</td>
                                                </tr>
                                            </tbody>

                                            <tbody v-if="!dataLoading && rows.length">
                                                <tr v-for="(row, index) in rows" :key="index" class="f14">

                                                    <td class="font-weight-semi-bold">
                                                        <router-link
                                                            :to="{ name: 'show-bookings', params: { id: row.encrypt_id } }"
                                                            class="default-color text-decoration-hover">
                                                            {{ row.confirmation_number }}
                                                        </router-link>
                                                    </td>

                                                    <td>{{ row.tenant_name }}</td>

                                                    <td>{{ row.package_title }}</td>

                                                    <td>
                                                        <span v-if="row.travel_month" class="font-weight-semi-bold">{{ travelMonthLabel(row) }}</span>
                                                        <span v-else class="text-muted">–</span>
                                                    </td>

                                                    <td>
                                                        <div>{{ row.user_name }}</div>
                                                        <small class="text-muted">{{ row.user_email }}</small>
                                                    </td>

                                                    <td class="text-nowrap">
                                                        <span v-if="row.ip_address"
                                                            class="d-inline-block text-truncate align-middle"
                                                            style="max-width:140px"
                                                            :title="row.ip_address">{{ row.ip_address }}</span>
                                                        <span v-else class="text-muted">–</span>
                                                    </td>

                                                    <td class="text-center font-weight-semi-bold">
                                                        {{ row.currency }} {{ Number(row.total_price).toFixed(2) }}
                                                    </td>

                                                    <td class="text-center">{{ row.adult_count }}</td>

                                                    <td class="text-center">
                                                        <span :class="statusBadge(row.status)">
                                                            {{ row.status }}
                                                        </span>
                                                    </td>

                                                    <td class="text-center">
                                                        <div class="dropdown">
                                                            <a class="u-icon-sm link-muted" href="javascript:;"
                                                                data-toggle="dropdown">
                                                                <span v-if="!row.loading" class="ti-more"></span>
                                                                <span v-if="row.loading" class="spinner-grow spinner-grow-sm mr-1" role="status" aria-hidden="true"></span>
                                                            </a>
                                                            <div class="dropdown-menu dropdown-menu-right" style="width:180px">
                                                                <div class="card border-0 p-3">
                                                                    <ul class="list-unstyled mb-0">
                                                                        <li>
                                                                            <router-link class="d-block link-dark"
                                                                                :to="{ name: 'show-bookings', params: { id: row.encrypt_id } }">
                                                                                View Details
                                                                            </router-link>
                                                                        </li>
                                                                        <li class="mt-2"><hr class="my-1"/></li>
                                                                        <li v-if="row.status != 'paid'">
                                                                            <a class="d-block link-dark" href="javascript:;"
                                                                                @click="updateStatus(row, 'paid')">Mark as Paid</a>
                                                                        </li>
                                                                        <li v-if="row.status != 'pending'">
                                                                            <a class="d-block link-dark" href="javascript:;"
                                                                                @click="updateStatus(row, 'pending')">Mark as Pending</a>
                                                                        </li>
                                                                        <li v-if="row.status != 'cancelled'">
                                                                            <a class="d-block link-dark" href="javascript:;"
                                                                                @click="updateStatus(row, 'cancelled')">Mark as Cancelled</a>
                                                                        </li>
                                                                        <li v-if="row.status != 'refunded'">
                                                                            <a class="d-block link-dark" href="javascript:;"
                                                                                @click="updateStatus(row, 'refunded')">Mark as Refunded</a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>

                                                </tr>
                                            </tbody>

                                            <tfoot>
                                                <tr>
                                                    <th>Confirmation #</th>
                                                    <th>Tenant</th>
                                                    <th>Package</th>
                                                    <th>Travel Date</th>
                                                    <th>Traveler</th>
                                                    <th>IP</th>
                                                    <th class="text-center">Total</th>
                                                    <th class="text-center">Adults</th>
                                                    <th class="text-center">Status</th>
                                                    <th class="text-center">Actions</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                    <!-- Pagination -->
                                    <nav v-if="rows.length" aria-label="Page navigation" style="margin-top:20px">
                                        <ul class="pagination">
                                            <li :class="[{disabled: !pagination.prev_page_url}]" class="page-item">
                                                <a class="page-link" href="javascript:;"
                                                    @click="fetchData(pagination.prev_page_url, true)">Previous</a>
                                            </li>
                                            <li :class="[{disabled: !pagination.next_page_url}]" class="page-item">
                                                <a class="page-link" href="javascript:;"
                                                    @click="fetchData(pagination.next_page_url, true)">Next</a>
                                            </li>
                                        </ul>
                                        <p class="pull-right ui-mt-50 f13">
                                            <i>Page {{ pagination.current_page }} of {{ pagination.last_page }}</i>
                                        </p>
                                    </nav>
                                    <!-- End Pagination -->

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card -->

                </div>

                <Footer></Footer>
            </div>
        </main>
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import iziToast from 'izitoast';

    export default {
        name: 'BookingList',
        components: { Header, Navigation, Footer },
        data() {
            return {
                auth: { role: '', access_token: '' },
                rows: [],
                pagination: {},
                dataLoading: true,
                tenantLoading: true,
                tenant_id: 0,
                tenant_name: 'All Tenants',
                tenants: [],
                search: '',
                filterStatus: '',
                show: 25,
                refs: 'bookings',
            };
        },
        created() {
            if (localStorage.getItem('role'))         this.auth.role = localStorage.getItem('role');
            if (localStorage.getItem('access_token')) this.auth.access_token = localStorage.getItem('access_token');
            if (localStorage.getItem('tenant_id'))    this.tenant_id = localStorage.getItem('tenant_id');
            if (localStorage.getItem('tenant_name'))  this.tenant_name = localStorage.getItem('tenant_name');
            this.fetchTenants();
        },
        methods: {
            travelMonthLabel(row) {
                const month = parseInt(row.travel_month, 10);
                if (!month) return '–';
                const months = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                const year = row.travel_year ? ' ' + row.travel_year : '';
                return (months[month] || 'Month ' + month) + year;
            },
            onSearchSubmit(value) {
                this.search = value;
                this.fetchData('', true);
            },
            onShow(n) {
                this.show = n;
                this.fetchData('', true);
            },
            changeStatus(s) {
                this.filterStatus = s;
                this.fetchData('', true);
            },
            changeTenant(id, name) {
                this.tenantLoading = true;
                this.tenant_id = id;
                this.tenant_name = name;
                localStorage.setItem('tenant_id', id);
                localStorage.setItem('tenant_name', name);
                this.fetchData('', true);
            },
            statusBadge(status) {
                const map = {
                    paid:      'badge badge-success',
                    pending:   'badge badge-warning',
                    cancelled: 'badge badge-danger',
                    refunded:  'badge badge-secondary',
                };
                return map[status] || 'badge badge-light';
            },

            fetchTenants() {
                this.tenantLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': 'Bearer ' + this.auth.access_token,
                };
                this.axios({ url: window.baseURL + '/tenants', method: 'GET', params: { status: 'active', paginate: 100 } })
                    .then(res => {
                        this.tenantLoading = false;
                        this.tenants = res.data.rows;
                        if (this.auth.role != 'root' && !localStorage.getItem('tenant_id')) {
                            this.tenant_id   = res.data.rows[0].id;
                            this.tenant_name = res.data.rows[0].name;
                        }
                        this.fetchData('', true);
                    })
                    .catch(err => {
                        if (err.response && err.response.status == 401) {
                            this.removeLocalStorage();
                            this.$router.push({ name: 'login' });
                        }
                    });
            },

            fetchData(pageUrl, loading = false) {
                if (loading) this.dataLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': 'Bearer ' + this.auth.access_token,
                };
                this.axios({
                    url: window.baseURL + '/' + this.refs,
                    method: 'GET',
                    params: {
                        tenant_id: this.tenant_id,
                        status:    this.filterStatus,
                        search:    this.search,
                        paginate:  this.show,
                        page: pageUrl ? (new URL(pageUrl)).searchParams.get('page') : null,
                    },
                })
                .then(res => {
                    this.dataLoading = false;
                    this.rows = res.data.rows;
                    if (res.data.paginate) this.makePagination(res.data.paginate);
                })
                .catch(err => {
                    this.dataLoading = false;
                    iziToast.warning({ icon: 'ti-alert', title: 'Error', message: err.response ? err.response.data.message : '' + err });
                });
            },

            makePagination(meta) {
                this.pagination = {
                    current_page:  meta.current_page,
                    last_page:     meta.last_page,
                    next_page_url: meta.next_page_url,
                    prev_page_url: meta.prev_page_url,
                };
            },

            updateStatus(row, status) {
                row.loading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': 'Bearer ' + this.auth.access_token,
                };
                this.axios({
                    url: window.baseURL + '/' + this.refs + '/' + row.encrypt_id + '/status',
                    method: 'PUT',
                    data: { status },
                })
                .then(() => {
                    row.status  = status;
                    row.loading = false;
                    iziToast.success({ icon: 'ti-check', title: 'Updated', message: 'Booking status set to ' + status });
                })
                .catch(err => {
                    row.loading = false;
                    iziToast.warning({ icon: 'ti-alert', title: 'Error', message: err.response ? err.response.data.message : '' + err });
                });
            },

            removeLocalStorage() {
                ['access_token','user_image','user_name','user_id','role','tenant_id'].forEach(k => localStorage.removeItem(k));
            },
        },
    };
</script>

<style scoped></style>
